import { useParamsSearch } from '@anytag/shared-hooks';
import { AnalyticsIgFeedPostsListSearchSchemaType } from '../../schema-types';

export const useAnalyticsIgComparePostsFilter = () => useParamsSearch<AnalyticsIgFeedPostsListSearchSchemaType>();
